import { Component } from '@angular/core';

@Component({
  selector: 'app-upload-demo-api-spec',
  imports: [],
  templateUrl: './upload-demo-api-spec.component.html',
  styleUrl: './upload-demo-api-spec.component.scss',
})
export class UploadDemoApiSpecComponent {}
